import { Flex, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { UnitQueueWireDto } from '@mark43/cad-api';
import { useTimeSince } from './use-time-since';
import { useUnitStateColor } from '../configurable-colors-sounds/use-configured-colors';
import { getConfiguredUnitStatusColors } from '../configurable-colors-sounds/unit-status-colors';
import { Tooltip } from '../common/components/tooltip';

const NOT_AVAILABLE = 'N/A';

export const FrUnitStatus = observer(function FrUnitStatus({
    unit,
    vertical,
}: {
    unit: UnitQueueWireDto;
    vertical?: boolean;
}) {
    const { statusCode, timeInStatusDateTime, unitStateGroup, unitStateId } = unit;
    const timeSince = useTimeSince(new Date(timeInStatusDateTime ?? new Date().toUTCString()));
    const timeSinceText = timeInStatusDateTime ? timeSince : NOT_AVAILABLE;
    const configuredColor = useUnitStateColor(unitStateId);
    const unitStatusColor = getConfiguredUnitStatusColors(configuredColor, unitStateGroup);

    return (
        <Flex userSelect="none" w="100%" justifyContent="center" alignItems="center">
            <Flex
                data-testid={`fr-unit-status-badge-${unit.id}`}
                h="100%"
                w="100%"
                borderRadius={vertical ? 'md' : 'var(--arc-radii-base)'}
                bgColor={
                    configuredColor.matched || unitStateGroup
                        ? unitStatusColor.fill
                        : 'surface.canvas'
                }
                alignItems="center"
                justifyContent="center"
                p={vertical ? 1 : 0}
                px={vertical ? 0 : 3}
                gap={vertical ? 2 : 4}
                flexDirection={vertical ? 'column' : 'row'}
            >
                <Text fontSize="lg" fontWeight="bold" lineHeight={1.5} style={{ color: unitStatusColor.text }}>
                    {statusCode}
                </Text>
                {vertical ? (
                    <Text noOfLines={1} fontSize="md" lineHeight={1.5} style={{ color: unitStatusColor.text }}>
                        {timeSinceText}
                    </Text>
                ) : (
                    <Tooltip overlay={timeSinceText}>
                        <Text noOfLines={1} fontSize="md" lineHeight={1.5}>
                            {timeSinceText}
                        </Text>
                    </Tooltip>
                )}
            </Flex>
        </Flex>
    );
});
